import { selectCpmUser } from "../../redux/feature/settings/configurations-slice";
import { store } from "../../redux/store/store";
import { validateString } from "../../utils/helpers/ObjectCheckerHelper";

const hasValue = (value?: string | null): value is string => typeof value === "string" && validateString(value);

export const resolveWorkflowActionUser = (): string | undefined => {
  if (typeof store?.getState !== "function") {
    return undefined;
  }
  const cpmUser = selectCpmUser(store.getState()) as
    | (ReturnType<typeof selectCpmUser> & { userName?: string })
    | undefined;
  return [cpmUser?.descriptionName, cpmUser?.email, cpmUser?.userName].find(hasValue);
};
